const whatsappUrl = "https://wa.me/qr/B5BVPSPSXGEBM1";

const galeriaItems = [
  {
    id: 1,
    src: "https://public.readdy.ai/ai/img_res/e5120d3c-7cc0-4b9b-b993-78f94a1c75ba.jpg",
    label: "Quartos sofisticados",
    tag: "Dormitório",
  },
  {
    id: 2,
    src: "https://readdy.ai/api/search-image?query=spacious%20modern%20living%20room%20with%20light%20wood%20vinyl%20flooring%2C%20white%20sofa%2C%20glass%20coffee%20table%2C%20open%20floor%20plan%2C%20large%20windows%2C%20contemporary%20Brazilian%20apartment%20interior%20design%2C%20ultra%20realistic%20photography&width=900&height=500&seq=gal002&orientation=landscape",
    label: "Salas que impressionam",
    tag: "Sala de Estar",
  },
  {
    id: 3,
    src: "https://readdy.ai/api/search-image?query=modern%20integrated%20kitchen%20and%20dining%20area%20with%20light%20oak%20vinyl%20plank%20flooring%2C%20white%20cabinets%2C%20marble%20countertop%2C%20pendant%20lights%2C%20minimalist%20Brazilian%20apartment%2C%20ultra%20realistic%20photography&width=900&height=500&seq=gal003&orientation=landscape",
    label: "Ambientes integrados",
    tag: "Cozinha & Sala",
  },
];

const extraItems = [
  {
    id: 4,
    src: "https://readdy.ai/api/search-image?query=modern%20home%20office%20with%20warm%20vinyl%20wood%20flooring%2C%20white%20desk%2C%20ergonomic%20chair%2C%20bookshelf%2C%20natural%20light%2C%20minimalist%20decor%2C%20sophisticated%20residential%20space%2C%20ultra%20realistic%20photography&width=600&height=400&seq=gal004&orientation=landscape",
    label: "Home Office",
  },
  {
    id: 5,
    src: "https://readdy.ai/api/search-image?query=luxury%20apartment%20corridor%20hallway%20with%20premium%20vinyl%20plank%20flooring%2C%20white%20walls%2C%20modern%20lighting%2C%20minimalist%20design%2C%20high-end%20residential%20interior%2C%20ultra%20realistic%20photography&width=600&height=400&seq=gal005&orientation=landscape",
    label: "Corredores",
  },
  {
    id: 6,
    src: "https://readdy.ai/api/search-image?query=cozy%20reading%20nook%20with%20warm%20wood%20vinyl%20flooring%2C%20armchair%2C%20floor%20lamp%2C%20bookshelf%2C%20soft%20natural%20light%2C%20elegant%20residential%20interior%20design%2C%20ultra%20realistic%20photography&width=600&height=400&seq=gal006&orientation=landscape",
    label: "Espaços de Leitura",
  },
];

export default function Galeria() {
  return (
    <section id="galeria" className="py-14 md:py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <span className="inline-block text-amber-700 text-xs font-bold tracking-widest uppercase mb-3">Galeria de Inspiração</span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-stone-800 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            Transformações reais
          </h2>
          <p className="text-stone-500 text-sm md:text-lg max-w-xl mx-auto">
            Veja como o piso vinílico transforma completamente qualquer ambiente
          </p>
          <div className="w-12 h-0.5 bg-amber-600 mx-auto mt-5" />
        </div>

        {/* Gallery: 2-col grid, all squares */}
        <div className="grid grid-cols-2 gap-3 md:gap-5 mb-10 md:mb-14">
          {[...galeriaItems, ...extraItems].map((item) => (
            <div
              key={item.id}
              className="relative rounded-xl md:rounded-2xl overflow-hidden group cursor-pointer aspect-square"
            >
              <img
                src={item.src}
                alt={item.label}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-transparent to-transparent" />
              <div className="absolute bottom-3 left-3 right-3 md:bottom-5 md:left-5">
                {'tag' in item && (
                  <span className="text-amber-400 text-[9px] md:text-xs font-bold tracking-widest uppercase leading-none block">{(item as typeof galeriaItems[0]).tag}</span>
                )}
                <p className="text-white text-xs md:text-lg font-semibold mt-0.5 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>{item.label}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-stone-500 text-sm mb-5">Quer ver seu ambiente assim? Solicite agora mesmo!</p>
          <a
            href="https://wa.me/11937354692?text=Ol%C3%A1%2C%20quero%20solicitar%20um%20or%C3%A7amento"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-amber-700 hover:bg-amber-600 text-white font-semibold text-sm px-8 py-3.5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-file-list-3-line text-base" />
            Solicite seu orçamento agora
          </a>
        </div>
      </div>
    </section>
  );
}